import Collapse from './Collapse';

export default Collapse;

export {
	Collapse,
};
